import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/es";
import { ServerChatMessage } from "./chat-message.types";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("es");

export const toLocal = (fechaHora: string) =>
  dayjs.utc(fechaHora).tz("America/Argentina/Buenos_Aires");

export const getLastMessage = <T extends ServerChatMessage>(
  messages: T[] | undefined,
): T | undefined =>
  [...(messages ?? [])].sort(
    (a, b) => dayjs.utc(b.fechaHora).valueOf() - dayjs.utc(a.fechaHora).valueOf(),
  )[0];
